export default __webpack_public_path__ + "static/media/lightHomeHistory.809a8b12.svg";